import axios from "axios";
import config from "./config";

export const fetchProfile = () => {
  return axios.get("/users/profile", config);
};
